<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="产品名:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入产品名称..." size="small" />
        </FormItem>
        <FormItem label="产品域:" prop="namespace">
          <Input v-model="formFields.namespace" placeholder="请输入产品域..." size="small" />
        </FormItem>
        <!-- <FormItem label="车辆类型:" prop="vehicleType">
          <Select
            v-model="formFields.vehicleType"
            clearable
            filterable
            placeholder="请选择车辆类型..."
            size="small"
          >
            <Option v-for="type in types" :key="type.id" :value="type.id" :label="type.name" />
          </Select>
        </FormItem> -->
        <FormItem label="备注:" prop="remarks">
          <Input v-model="formFields.remarks" placeholder="请输入备注..." size="small" />
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'ProductDialog',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        name: '',
        namespace: '',
        remarks: '',
        id: this.id,
        vehicleType: 0
      },
      ruleValidate: {
        vehicleType: [
          { required: true, message: '车辆类型不能为空!' }
        ],
        name: [
          { required: true, message: '产品名不能为空!', trigger: 'blur' }
        ],
        namespace: [
          { required: true, message: '产品域名不能为空!', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑产品' : '添加新产品'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        // this.loadVehicleTypes()
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          this.formFields = res.data
        }).catch(error => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          console.log(error)
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    // async loadVehicleTypes() {
    //   await request({
    //     url: this.$config.apiContextPath + '/vehicle/type?fetchAll=true',
    //     method: 'get'
    //   }).then(res => {
    //     this.types = res.data.content
    //   }).catch(error => {
    //     console.log(error)
    //     this.types = []
    //   })
    // },
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      if (this.action) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit = true
            const isNew = this.formFields.id === 0
            request({
              url: this.action + (isNew ? '' : ('/' + this.id)),
              method: isNew ? 'POST' : 'PUT',
              data: this.formFields
            }).then(res => {
              this.loadingStatus = false
              this.formFields = res.data
              this.$Notice.success({
                title: '数据保存成功',
                desc: '产品 `' + this.formFields.name + '` 保存成功!'
              })
              this.submit = false
              this.closeModal(true)
            }).catch(error => {
              // this.$Notice.error({
              //   title: '服务器数据请求失败',
              //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
              // })
              console.log(error)
              this.loadingStatus = false
              this.submit = false
            })
          }
        })
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
